export enum NpsReviewBucket {
    Excellent = 'excellent',
    Great = 'great',
    Average = 'average',
    Poor = 'poor',
    Bad = 'bad',
}
